import { Box } from '@mui/material'
import React, { FunctionComponent } from 'react'

export const CenterBox: FunctionComponent = ({ children }) => (
  <Box display="flex" width="100%" flexWrap="wrap" alignItems="center" justifyContent="center">
    {children}
  </Box>
)
